var render = function render(_c,_vm){return _c('div',{staticClass:"field is-horizontal"},[_c('div',{staticClass:"field-label"},[_vm._t("label")],2),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }